import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/dash/mocker'

export default {
  receivedTinitial () {
    if (isMock) return generator(mocker.tinitial())
    return instance().get(endpoint + '/dash/tinitial')
  },
  receivedTfolder () {
    if (isMock) return generator(mocker.tfolder())
    return instance().get(endpoint + '/dash/tfolder')
  },
  receivedModules () {
    if (isMock) return generator(mocker.modules())
    return instance().get(endpoint + '/dash/modules')
  },
  receivedHeaderNotiTotal ($staappr) {
    if (isMock) return generator(mocker.headerNotiTotal())
    return instance().get(endpoint + '/dash/notiTotal/' + $staappr)
  },
  receivedHeaderNotiAnnounceInfiniteLoading (searchParams) {
    if (isMock) return generator(mocker.headerNotiAnnounce())
    return instance().get(endpoint + '/dash/notiAnnounce', { params: searchParams })
  },
  receivedHeaderNotiRequestInfiniteLoading (staappr, searchParams) {
    if (isMock) return generator(mocker.headerNotiRequest())
    return instance().get(endpoint + '/dash/notiRequest/' + staappr, { params: searchParams })
  },
  getMailLang () {
    if (isMock) return generator(mocker.getMailLang())
    return instance().get(endpoint + '/dash/mailLang')
  },
  postMailLang (mailLang) {
    if (isMock) return generator(mocker.postMailLang())
    return instance().post(endpoint + '/dash/saveMailLang/' + mailLang)
  }
}



// WEBPACK FOOTER //
// ./src/api/dash/index.js